// 产品数据管理文件
// 用于集中管理product.vue和productDatails.vue页面的所有数据，从JSON文件动态加载

// 缓存机制：避免重复请求
let cachedProductData = null;
let cacheTimestamp = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5分钟缓存

// 获取产品数据
export const getProductData = async () => {
  // 检查缓存是否有效
  const now = Date.now();
  if (cachedProductData && (now - cacheTimestamp) < CACHE_DURATION) {
    return cachedProductData;
  }

  try {
    // 从JSON文件获取数据
    const response = await fetch('/data/product.json');
    if (!response.ok) {
      throw new Error('Failed to fetch product data');
    }
    
    const data = await response.json();
    
    // 更新缓存
    cachedProductData = data;
    cacheTimestamp = now;
    
    return data;
  } catch (error) {
    console.error('Error fetching product data:', error);
    // 返回默认数据结构，确保应用正常运行
    return {
      productListData: {
        bikeormore: [],
        sale: []
      },
      productDetailData: {
        "1": {
          images: [],
          info: {
            name: "",
            price: 0,
            brandStory: {
              paragraph1: "",
              paragraph2: "",
              paragraph3: ""
            },
            colors: [],
            sizes: []
          },
          features: [],
          details: []
        }
      }
    };
  }
};

// 根据type参数获取商品列表
export const getProductList = async (type = 'bikeormore') => {
  try {
    const data = await getProductData();
    // 根据type参数返回不同的数据
    return data.productListData[type] || data.productListData.bikeormore;
  } catch (error) {
    console.error('Error getting product list:', error);
    return [];
  }
};

// 获取产品详情
export const getProductDetail = async (productId) => {
  try {
    const data = await getProductData();
    // 返回对应ID的产品详情，如果不存在则返回默认产品
    return data.productDetailData[productId] || data.productDetailData['1'];
  } catch (error) {
    console.error('Error getting product detail:', error);
    return {
      images: [],
      info: {
        name: "",
        price: 0,
        brandStory: {
          paragraph1: "",
          paragraph2: "",
          paragraph3: ""
        },
        colors: [],
        sizes: []
      },
      features: [],
      details: []
    };
  }
};

// 根据type参数和产品ID获取带价格信息的产品详情（用于在详情页显示与列表页一致的价格）
export const getProductDetailWithPrice = async (productId, type = 'bikeormore') => {
  // 获取产品详情
  const detail = await getProductDetail(productId);
  // 获取对应类型的产品列表
  const productList = await getProductList(type);
  // 查找对应的产品信息
  const productInfo = productList.find(p => p.id === parseInt(productId));
  
  if (productInfo) {
    // 更新价格信息，确保详情页显示与列表页一致的价格
    detail.info.price = productInfo.price;
    if (productInfo.discountPrice) {
      detail.info.discountPrice = productInfo.discountPrice;
    } else {
      // 如果没有折扣价，移除可能存在的折扣价属性
      delete detail.info.discountPrice;
    }
  }
  
  return detail;
};

// 导出默认对象，便于导入使用
export default {
  getProductList,
  getProductDetail,
  getProductDetailWithPrice,
};